function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "marketing",
  transform: "translate(0 -6.117)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3086",
  "data-name": "Group 3086",
  transform: "translate(0 6.117)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3085",
  "data-name": "Group 3085",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_282",
  "data-name": "Rectangle 282",
  width: 8.852,
  height: 20.359,
  transform: "translate(26.581 39.571)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_283",
  "data-name": "Rectangle 283",
  width: 8.852,
  height: 33.637,
  transform: "translate(49.596 26.293)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_284",
  "data-name": "Rectangle 284",
  width: 8.852,
  height: 11.507,
  transform: "translate(3.566 48.422)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_329",
  "data-name": "Path 329",
  d: "M61.722,7.714a1.417,1.417,0,0,0-.974-.443L44.727,6.12a1.331,1.331,0,1,0-.177,2.655l12.481.885L34.9,27.01,18.614,14.175a1.239,1.239,0,0,0-1.751.067l-.019.021L.379,30.02a1.328,1.328,0,0,0,0,1.859,1.416,1.416,0,0,0,.974.443,1.416,1.416,0,0,0,.885-.443l15.579-14.96,16.2,12.747a1.328,1.328,0,0,0,1.682.088L59.155,11.431l-.974,11.95A1.328,1.328,0,0,0,59.415,24.8h.094a1.239,1.239,0,0,0,1.327-1.144v-.006l1.151-14.96A1.24,1.24,0,0,0,61.722,7.714Z",
  transform: "translate(0 -6.117)",
  fill: "#ac1ede"
}))));

var SvgMarketing = function SvgMarketing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.003,
    height: 59.93,
    viewBox: "0 0 62.003 59.93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarketing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marketing.faeabcec.svg";
export { ForwardRef as ReactComponent };